const searchTimeout = 250;

export default searchTimeout;
